var map = {
	"./3-2-placeholder.png": "d51b",
	"./Item_View.svg": "dc13",
	"./bblogo.png": "9166",
	"./fonts/backbone-icons.ttf": "905b",
	"./inactive-overlay.svg": "e00f",
	"./logo.png": "383a",
	"./logo.svg": "2a97",
	"./placeholder-square.png": "55a1",
	"./placeholder.png": "4b5b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "74c8";